<details class="govuk-details" data-module="govuk-details">
    <summary class="govuk-details__summary">
      <span class="govuk-details__summary-text">
        Help
      </span>
    </summary>
    <div class="govuk-details__text">
        {{detailsData}}
    </div>
  </details> 